import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CustomerManagementService } from '../../../services/customer.service';
import { CustomerAddress } from '../../../models/customer.model';
import { AlertService } from 'src/app/core/alert.service';
import { AuthorizationBase } from 'src/app/core/authorize-base';

@Component({
  selector: 'app-customer-address-form',
  templateUrl: './customer-address-form.component.html',
  styleUrls: ['./customer-address-form.component.scss'],
})
export class CustomerAddressFormComponent extends AuthorizationBase implements OnInit, OnDestroy {
  @Input() customerId: number;
  @Input() editMode: boolean = false;

  @Input() customerAddress: CustomerAddress = new CustomerAddress();
  states: any[];
  countries: any[];
  isLoading: boolean = false;
  isSubmitted: boolean = false;

  selectedAddressType: number = 1;
  addressTypes: any = [
    { name: 'Home', value: 1 },
    { name: 'Office', value: 2 },
    { name: 'Shipping', value: 3 },
    { name: 'Billing', value: 4 },
  ];

  readonly unsubscribe$ = new Subject();

  constructor(
    private apiService: CustomerManagementService,
    private activeModal: NgbActiveModal,
    private alert: AlertService,
  ) { 
    super();
  }

  ngOnInit() {
   
    if(!this.editMode) {
      this.customerAddress = new CustomerAddress();
    }
    
    forkJoin({
      states: this.apiService.usaStates(),
      countries: this.apiService.getAllCountries(),
    })
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any) => {
        for (const [key, value] of Object.entries(data)) {
          this[key] = value;
        }

        this.customerAddress.CustomerId = this.customerId;
        this.customerAddress.CountryId = 230;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  close(data?: any): void {
    this.activeModal.close(data);
  }

  onAddressTypeSelected(type: number): void {
    this.selectedAddressType = type;
    this.customerAddress.AddressType = this.selectedAddressType;
  }

  onCountryChanged(countryCode: number): void {
    this.customerAddress.CountryId = countryCode;
  }

  onSave(isValid: boolean): void {
    this.isSubmitted = true;

    if (isValid) {
      
      this.isLoading = true;
      if(!this.editMode) {
        this.customerAddress.UpdatedBy = !isNaN(Number(this.userId)) ? Number(this.userId) : 0;
        this.customerAddress.CreatedBy = !isNaN(Number(this.userId)) ? Number(this.userId) : 0;
      } else {
        this.customerAddress.UpdatedBy = !isNaN(Number(this.userId)) ? Number(this.userId) : 0;
      }
      
      
      this.apiService.addAddress(this.customerAddress)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((address: any) => {
          this.alert.alertSuccess({
            title: 'Success',
            text: this.editMode
              ? 'Successfully updated an address!'
              : 'Successfully added a new address!',
          }).then(() => {
            this.isLoading = false;
            this.isSubmitted = false;

            this.close(address.CustomerAddress);
          });
        });
    }
  }
}
